import { Modal } from '@taxbit-private/cosmic'
import React from 'react'

type TConfirmDialogType = 'default' | 'danger' | 'info'

export type TConfirmDialogOptions = {
  title: string
  content: React.ReactNode | string
  dialogType: TConfirmDialogType
  confirmationText: string
  cancellationText: string
  cosmicVersion?: boolean
}

export type IConfirmDialog = {
  isOpen: boolean
  onConfirm: () => void
  onClose: () => void
  onCancel: () => void
  options: TConfirmDialogOptions
}

export const ConfirmDialog = ({
  isOpen: open,
  onConfirm,
  onClose,
  onCancel,
  options,
}: IConfirmDialog) => {
  const { title, content, dialogType, confirmationText, cancellationText } = options

  const dialogTypeMap = () => {
    const typeMap: Record<TConfirmDialogType, 'button-primary' | 'button-danger'> = {
      default: 'button-primary',
      info: 'button-primary',
      danger: 'button-danger',
    }

    return typeMap[dialogType]
  }

  return (
    <Modal
      title={title}
      isOpen={open}
      onClose={onClose}
      closeButtonTrackingId="dialog-close-button-tracking-id"
      primaryButtonProps={{
        label: confirmationText,
        trackingId: 'dialog-confirm-button-tracking-id',
        variant: dialogTypeMap(),
        onClick: onConfirm,
      }}
      secondaryButtonProps={{
        label: cancellationText,
        trackingId: 'dialog-cancel-button-tracking-id',
        onClick: onCancel,
      }}
    >
      {content}
    </Modal>
  )
}
